import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { MOST_NEGATIVE_SINGLE_FLOAT, MOST_POSITIVE_SINGLE_FLOAT } from '../constants';
import { getNativeContext } from '../helpers/get-native-context';
import { setInternalState } from '../helpers/set-internal-state';
import { wrapEventListener } from '../helpers/wrap-event-listener';
var DEFAULT_OPTIONS = {
  channelCount: 2,
  channelCountMode: 'max',
  channelInterpretation: 'speakers',
  offset: 1
};
export var createConstantSourceNodeConstructor = function createConstantSourceNodeConstructor(createAudioParam, createConstantSourceNodeRendererFactory, createNativeConstantSourceNode, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(ConstantSourceNode, _noneAudioDestination);

      function ConstantSourceNode(context) {
        var _this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

        _classCallCheck(this, ConstantSourceNode);

        var nativeContext = getNativeContext(context);

        var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

        var nativeConstantSourceNode = createNativeConstantSourceNode(nativeContext, mergedOptions);
        var isOffline = isNativeOfflineAudioContext(nativeContext);
        var constantSourceNodeRenderer = isOffline ? createConstantSourceNodeRendererFactory() : null;
        _this = _possibleConstructorReturn(this, _getPrototypeOf(ConstantSourceNode).call(this, context, 'passive', nativeConstantSourceNode, constantSourceNodeRenderer));
        _this._constantSourceNodeRenderer = constantSourceNodeRenderer;
        _this._nativeConstantSourceNode = nativeConstantSourceNode;
        /*
         * Bug #62 & #74: Edge & Safari do not support ConstantSourceNodes and do not export the correct values for maxValue and
         * minValue for GainNodes.
         */

        _this._offset = createAudioParam(_assertThisInitialized(_this), isOffline, nativeConstantSourceNode.offset, MOST_POSITIVE_SINGLE_FLOAT, MOST_NEGATIVE_SINGLE_FLOAT);
        _this._onended = null;
        return _this;
      }

      _createClass(ConstantSourceNode, [{
        key: "start",
        value: function start() {
          var _this2 = this;

          var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          this._nativeConstantSourceNode.start(when);

          if (this._constantSourceNodeRenderer !== null) {
            this._constantSourceNodeRenderer.start = when;
          } else {
            setInternalState(this, 'active');

            var setInternalStateToInactive = function setInternalStateToInactive() {
              _this2._nativeConstantSourceNode.removeEventListener('ended', setInternalStateToInactive); // @todo Determine a meaningful delay instead of just using one second.


              setTimeout(function () {
                return setInternalState(_this2, 'passive');
              }, 1000);
            };

            this._nativeConstantSourceNode.addEventListener('ended', setInternalStateToInactive);
          }
        }
      }, {
        key: "stop",
        value: function stop() {
          var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          this._nativeConstantSourceNode.stop(when);

          if (this._constantSourceNodeRenderer !== null) {
            this._constantSourceNodeRenderer.stop = when;
          }
        }
      }, {
        key: "offset",
        get: function get() {
          return this._offset;
        }
      }, {
        key: "onended",
        get: function get() {
          return this._onended;
        },
        set: function set(value) {
          var wrappedListener = wrapEventListener(this, value);
          this._nativeConstantSourceNode.onended = wrappedListener;
          var nativeOnEnded = this._nativeConstantSourceNode.onended;
          this._onended = nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
      }]);

      return ConstantSourceNode;
    }(noneAudioDestinationNodeConstructor)
  );
};